import type { InteractionBlueprintData } from "./interactionBlueprintSchema";
import { ADVISOR_CONTENT_KEYS } from "@/constants/contentItemKeys";
import { collectOpaqueFieldPaths } from "./opaqueFieldPaths";
import { parseContentItem } from "./contentItem";
import { parseTextContent } from "./text";
import {
  interactionBlueprintFieldsSchema,
  parseInteractionBlueprintFromFields,
  parseWithRecord,
} from "./schemas";

export const parseInteractionBlueprint = (
  data: unknown,
): InteractionBlueprintData => {
  const interactionBlueprintRaw =
    data != null && typeof data === "object"
      ? (JSON.parse(JSON.stringify(data)) as unknown)
      : undefined;

  const parsed = parseWithRecord(data, interactionBlueprintFieldsSchema);
  const contentRaw: unknown = parsed.content;
  let content: InteractionBlueprintData["content"] = [];

  if (Array.isArray(contentRaw)) {
    content = contentRaw.map((item, index) =>
      parseContentItem(item, String(index)),
    );
  } else if (
    contentRaw !== null &&
    typeof contentRaw === "object" &&
    !Array.isArray(contentRaw)
  ) {
    const entries = Object.entries(contentRaw as Record<string, unknown>);
    content = entries.map(([formLabel, item]) =>
      parseContentItem(item, formLabel),
    );
  }

  let advisorContent: InteractionBlueprintData["advisorContent"];
  if (
    parsed.advisorContent != null &&
    typeof parsed.advisorContent === "object" &&
    ADVISOR_CONTENT_KEYS.SUMMARY in parsed.advisorContent
  ) {
    const raw = parsed.advisorContent as {
      [key: string]: unknown;
    };
    advisorContent = {
      summary:
        raw[ADVISOR_CONTENT_KEYS.SUMMARY] != null
          ? parseTextContent(raw[ADVISOR_CONTENT_KEYS.SUMMARY])
          : undefined,
    };
  } else {
    advisorContent = undefined;
  }

  const core = parseInteractionBlueprintFromFields(
    parsed,
    content,
    advisorContent,
  );
  const opaqueFieldPaths =
    interactionBlueprintRaw != null
      ? collectOpaqueFieldPaths(interactionBlueprintRaw, core)
      : [];

  return {
    ...core,
    ...(interactionBlueprintRaw !== undefined
      ? { interactionBlueprintRaw }
      : {}),
    ...(opaqueFieldPaths.length > 0 ? { opaqueFieldPaths } : {}),
  };
};
